import React from "react";
import SingleCard from "../components/SingleCard";

export default function StartupDetails() {
  return (
    <div>
      <SingleCard />
    </div>
  );
}
